import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.Element
import org.w3c.dom.HTMLInputElement
import xyz.luan.bpc.BPC
import xyz.luan.bpc.parser.ParsingException

fun main() {
    window.onload = {
        inline fun <reified T : Element> get(id: String): T {
            val element = document.getElementById(id) ?: error("Element $id not found")
            return element as? T ?: error("Element $id is not of type ${T::class.simpleName}")
        }

        fun getValue(id: String): String {
            return get<HTMLInputElement>(id).value.trim()
        }

        val resultDiv = get<Element>("result")
        val calculateButton = get<Element>("calculate")

        val circleInputs = (1..4).map { get<Element>("circle-$it") }
        calculateButton.addEventListener("click", { event ->
            val result = try {
                val value = BPC.resolve(
                    circles = circleInputs.map { input -> getValue(input.id) },
                    centre = getValue("centre"),
                    markings = getValue("markings"),
                )
                "Result: $value"
            } catch (t: ParsingException) {
                "Error: ${t.message}"
            }
            resultDiv.innerHTML = result
        })
    }
}
